/**
 * Neighbours for the public cluster. Anchors name the page; none say "here".
 * App routes fall back to the overview's neighbours so a stamped shell is not an orphan.
 */

/** @typedef {{ href: string, label: string }} InternalLink */

/** @type {Record<string, InternalLink[]>} */
const RELATED = {
  '/': [
    { href: '/pricing/', label: 'Hesychia pricing — $10/month, no ads' },
    { href: '/privacy/', label: 'What Hesychia stores and does not sell' },
    { href: '/changelog/', label: 'Dated Hesychia product updates' },
    { href: '/terms_of_service/', label: 'Hesychia terms of service' },
    { href: '/account-deletion/', label: 'How to request Hesychia account deletion' },
  ],
  '/pricing/': [
    { href: '/', label: 'What Hesychia is' },
    { href: '/privacy/', label: 'What Hesychia stores and does not sell' },
    { href: '/changelog/', label: 'Dated Hesychia product updates' },
    { href: '/terms_of_service/', label: 'Hesychia terms of service' },
  ],
  '/privacy/': [
    { href: '/', label: 'What Hesychia is' },
    { href: '/pricing/', label: 'Hesychia pricing — $10/month, no ads' },
    { href: '/terms_of_service/', label: 'Hesychia terms of service' },
    { href: '/account-deletion/', label: 'How to request Hesychia account deletion' },
  ],
  '/changelog/': [
    { href: '/', label: 'What Hesychia is' },
    { href: '/pricing/', label: 'Hesychia pricing — $10/month, no ads' },
    { href: '/privacy/', label: 'What Hesychia stores and does not sell' },
    { href: '/terms_of_service/', label: 'Hesychia terms of service' },
  ],
  '/terms_of_service/': [
    { href: '/', label: 'What Hesychia is' },
    { href: '/pricing/', label: 'Hesychia pricing — $10/month, no ads' },
    { href: '/privacy/', label: 'What Hesychia stores and does not sell' },
    { href: '/account-deletion/', label: 'How to request Hesychia account deletion' },
  ],
  '/account-deletion/': [
    { href: '/', label: 'What Hesychia is' },
    { href: '/privacy/', label: 'What Hesychia stores and does not sell' },
    { href: '/terms_of_service/', label: 'Hesychia terms of service' },
    { href: '/pricing/', label: 'Hesychia pricing — $10/month, no ads' },
  ],
};

const GENERIC_ANCHOR = /^(here|click here|read more|learn more)$/i;

/**
 * @param {string} pathname
 * @returns {InternalLink[]}
 */
function linksForPath(pathname) {
  if (pathname === '/legal/terms-of-service') return RELATED['/terms_of_service/'];
  return RELATED[pathname] || RELATED['/'].slice(0, 4);
}

/**
 * @param {string} pathname
 * @returns {string}
 */
function relatedNavHtml(pathname) {
  const links = linksForPath(pathname);
  if (links.length < 2 || links.length > 5) {
    throw new Error(`related links for ${pathname} must be 2-5, found ${links.length}`);
  }
  const inner = links
    .map((link) => {
      if (link.href === pathname) {
        throw new Error(`related nav on ${pathname} links to itself`);
      }
      if (GENERIC_ANCHOR.test(link.label.trim())) {
        throw new Error(`generic anchor on ${pathname}: ${link.label}`);
      }
      return `<a href="${link.href}">${link.label}</a>`;
    })
    .join('');
  return `<nav aria-label="Related pages">${inner}</nav>`;
}

module.exports = {
  RELATED,
  linksForPath,
  relatedNavHtml,
};
